import { columnDataType, dateTypeEnum, numberTypeEnum, textTypeEnum } from "utils/types";
import { v4 } from "uuid";

export class FilterSettingsService {
  static filterItemsOptionsObject = {
    [columnDataType.text]: [
      {
        key: textTypeEnum.predictValue,
        value: "Model values",
        hasInput: false,
        hasSecondInput: false,
        hasDropdown: true,
      },
      {
        key: textTypeEnum.empty,
        value: "empty",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.notEmpty,
        value: "not empty",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textContains,
        value: "text contains",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textDoesNotContain,
        value: "text does not contain",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textStartsWith,
        value: "text starts with",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textEndsWith,
        value: "text ends with",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textIsExactly,
        value: "text is exactly",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
    ],
    [columnDataType.date]: [
      {
        key: dateTypeEnum.predictValue,
        value: "Model values",
        hasInput: false,
        hasSecondInput: false,
        hasDropdown: true,
      },
      {
        key: dateTypeEnum.empty,
        value: "empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: dateTypeEnum.notEmpty,
        value: "not empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: dateTypeEnum.dateIs,
        value: "date is",
        hasDatepicker: true,
        hasSecondDatepicker: false,
      },
      {
        key: dateTypeEnum.dateIsBefore,
        value: "date is before",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: false,
      },
      {
        key: dateTypeEnum.dateIsAfter,
        value: "date is after",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: false,
      },
      {
        key: dateTypeEnum.isBetween,
        value: "is between",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: true,
      },
      {
        key: dateTypeEnum.isNotBetween,
        value: "is not between",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: true,
      },
    ],
    [columnDataType.checkbox]: [
      {
        key: dateTypeEnum.notEmpty,
        value: "is set",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: dateTypeEnum.empty,
        value: "not set",
        hasInput: false,
        hasSecondInput: false,
      },
    ],
    [columnDataType.number]: [
      {
        key: numberTypeEnum.predictValue,
        value: "Model values",
        hasInput: false,
        hasSecondInput: false,
        hasDropdown: true,
      },
      {
        key: numberTypeEnum.empty,
        value: "empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: numberTypeEnum.notEmpty,
        value: "not empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: numberTypeEnum.moreThan,
        value: "more than",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.moreThanOrEqualTo,
        value: "more than or equal to",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.lessThan,
        value: "less than",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.lessThanOrEqualTo,
        value: "less than or equal to",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.equal,
        value: "equal",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.notEqual,
        value: "not equal",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.isBetween,
        value: "is between",
        hasInput: true,
        hasSecondInput: true,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.isNotBetween,
        value: "is not between",
        hasInput: true,
        hasSecondInput: true,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
    ],
  };

  static createFilterItemSetting(columnType) {
    const newItemObject = {
      id: v4(),
      type: columnType,
      options: this.filterItemsOptionsObject[columnType],
      inputsDataArray: [],
      selectedOption: null,
    };

    return newItemObject;
  }

  static createFilterSchemeConditions(filterItems) {
    const conditions = [];

    filterItems.forEach((filterItem) => {
      if (filterItem?.selectedOption?.key) {
        conditions.push({
          type: filterItem?.selectedOption?.key,
          dataArray: filterItem.inputsDataArray,
        });
      }
    });

    return conditions;
  }

  static createFilterScheme({
    columnKey,
    columnType,
    filterItems = null,
  }) {
    const conditions = this.createFilterSchemeConditions(filterItems);

    return {
      columnKey: columnKey,
      columnType: columnType,
      conditions: conditions,
    };
  }
}
